import { AppRoutes } from '../../core/routes/routes';

export const basePath = `admin`;

export const baseUrl = `/${basePath}`;

export const routes = {
  dashboard: {
    path: 'dashboard',
    url: () => `${baseUrl}/dashboard`,
  },
  brands: {
    index: {
      path: 'brands',
      url: () => `${baseUrl}/brands`,
    },
    detail: {
      path: 'brands/:brandId',
      url: (args: { brandId: string }) => `${baseUrl}/brands/${args.brandId}`,
    },
  },
  listings: {
    index: {
      path: 'listings',
      url: () => `${baseUrl}/listings`,
    },
    detail: {
      root: {
        path: 'listings/:listingId',
        url: (args: { listingId: string }) => `${baseUrl}/listings/${args.listingId}`,
      },
      overview: {
        path: 'overview',
        url: (args: { listingId: string }) => `${baseUrl}/listings/${args.listingId}/overview`,
      },
      applications: {
        index: {
          path: 'applications',
          url: (args: { listingId: string }) => `${baseUrl}/listings/${args.listingId}/applications`,
        },
      },
      creators: {
        path: 'creators',
        url: (args: { listingId: string }) => `${baseUrl}/listings/${args.listingId}/creators`,
      },
    },
    orders: {
      detail: {
        path: 'listings/:listingId/orders/:orderId',
        url: (args: { listingId: string; orderId: string }) => `${baseUrl}/listings/${args.listingId}/orders/${args.orderId}`,
      },
    },
  },
  creators: {
    index: {
      path: 'creators',
      url: () => `${baseUrl}/creators`,
    },
    preview: {
      path: ':creatorId/preview',
      url: (args: { creatorId: string }) => `${baseUrl}/creators/${args.creatorId}/preview`,
    },
    orders: {
      path: ':creatorId/orders',
      url: (args: { creatorId: string }) => `${baseUrl}/creators/${args.creatorId}/orders`,
    },
  },
  orders: {
    index: {
      path: 'orders',
      url: () => `${baseUrl}/orders`,
    },
    detail: {
      path: 'orders/:orderId',
      url: (args: { listingId: string; orderId: string }) => `${baseUrl}/orders/${args.orderId}?listingId=${args.listingId}`,
    },
  },
  products: {
    index: {
      path: 'products',
      url: () => `${baseUrl}/products`,
    },
  },
  finances: {
    index: {
      path: 'finances',
      url: () => `${baseUrl}/finances`,
    },
  },
  settings: {
    index: {
      path: 'settings',
      url: () => `${baseUrl}/settings`,
    },
    account: {
      path: 'account',
      url: () => `${baseUrl}/settings/account`,
    },
    users: {
      path: 'users',
      url: () => `${baseUrl}/settings/users`,
    },
  },
  help: {
    index: {
      path: 'help',
      url: () => `${baseUrl}/help`,
    },
  },
} as const satisfies AppRoutes;
